import {
  NAV_ISOPEN,
  NAV_RESET,
  NAV_SET_CURRENT_LEVEL,
  NAV_SET_CURRENT_EXPANDED,
  NAV_RESET_CURRENT_EXPANDED
} from '../actions/navigation';

const initialState = {
  isOpen: false,
  currentLevel: 1,
  currentExpanded: {
    '2': '',
    '3': ''
  }
};

const navigation = (state = initialState, action) => {
  switch (action.type) {
    case NAV_ISOPEN:
      if (!state.isOpen) {
        document.body.classList.add('navigation--is-open');
      } else {
        document.body.classList.remove('navigation--is-open');
      }
      return {
        ...state,
        isOpen: !state.isOpen
      };

    case NAV_RESET:
      document.body.classList.remove('navigation--is-open');

      return {
        ...state,
        ...initialState
      };

    case NAV_SET_CURRENT_LEVEL:
      return {
        ...state,
        currentLevel: action.currentLevel
      };

    case NAV_SET_CURRENT_EXPANDED:
      return {
        ...state,
        currentExpanded: {
          ...state.currentExpanded,
          [action.level]: action.currentExpanded
        }
      };

    case NAV_RESET_CURRENT_EXPANDED:
      return {
        ...state,
        currentExpanded: initialState.currentExpanded
      };

    default:
      return state;
  }
};

export default navigation;
